{
	"titleFirstPart": "Welcome to the",
	"titleSecondPart": "Heidelberg Materials {{productName}}",
	"totalCarbonStored": "Total carbon stored"
}
